export function IsNullOrEmpty( string) {
  
   if (string === null || string === undefined  || string.trim() === "") {
    return true;
   }
    return false;
    }